import React from 'react'
import ParticipantTable from './Table'

const Table = (props) => (
  <ParticipantTable {...props} />
)

export default Table



// WEBPACK FOOTER //
// ./src/components/Table/index.js